import React from "react";
import Slider from "react-slick";
const HomeSlider = () => {
  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    adaptiveHeight: true,
  };
  return (
    <>
      <div className="slider-sec">
        <Slider {...settings}>
          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
            {/* <div className="slider-info">
              <h4> Ignite Minds, Shape Futures, Learn Today, Lead Tomorrow </h4>
              <p>
                Opening Doors to Limitless Possibilities, Unlock Your Potential
                Through Learning, and Knowledge Empowers Every Step. {" "}
              </p>
            </div> */}
          </div>
          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider1.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>
        

          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider7.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>
          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider8.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>
          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider9.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>
          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider10.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>
           <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider11.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>


          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider2.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>
          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider3.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>
          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider4.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>
          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider5.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>
          <div>
            <img
              src="https://webapi.entab.info/api/image/SJCSQP/public/Images/slider6.jpg"
              className="d-block w-100"
              alt="St. Josephs School Quadian Punjab"
            />
          </div>

        </Slider>
      </div>
    </>
  );
};

export default HomeSlider;
